module.exports = __webpack_public_path__ + "img/folha-icon.0a15f220.png";